import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Crop } from "@/types/crop";
import { Edit, Leaf } from "lucide-react";

interface CropsListProps {
  crops: Crop[];
  onEditCrop?: (crop: Crop) => void;
  canEdit?: boolean;
}

const CropsList: React.FC<CropsListProps> = ({ crops, onEditCrop, canEdit = false }) => {
  const showEditAction = onEditCrop && canEdit;

  return (
    <div className="w-full overflow-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Description</TableHead>
            {showEditAction && <TableHead className="w-[80px]">Actions</TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {crops.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={showEditAction ? 3 : 2}
                className="h-24 text-center">
                <div className="flex flex-col items-center gap-2 text-muted-foreground">
                  <Leaf className="h-8 w-8" />
                  <span>No crops found. Add your first crop!</span>
                </div>
              </TableCell>
            </TableRow>
          ) : (
            [...crops]
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((crop) => (
                <TableRow key={crop.id}>
                  <TableCell className="font-medium">
                    {crop.name}
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {crop.description || "-"}
                  </TableCell>
                  {showEditAction && (
                    <TableCell>
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => onEditCrop(crop)}
                        className="h-8 w-8 p-0">
                        <Edit className="h-4 w-4" />
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default CropsList;
